import { render, staticRenderFns } from "./McpProcedureGroups.vue?vue&type=template&id=803d571e"
import script from "./McpProcedureGroups.vue?vue&type=script&lang=js"
export * from "./McpProcedureGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports